import { getImpersonationHeader } from '../auth'

export const getIsImpersonating = () => {
  const impersonationHeader = getImpersonationHeader()
  return !!(impersonationHeader && impersonationHeader['X-PGA-Impersonation'])
}

